import cn from "classnames";
import Link from "next/link";
import Image from "next/image";

export default function CoverImage({ title, url, slug }) {
  const image = (
    <img
      src={url}
      alt={`Cover Image for ${title}`}
      className={cn("shadow-sm rounded-lg", {
        "hover:shadow-md transition-shadow duration-200": slug,
      })}
      layout="intrinsic"  // Use intrinsic to maintain aspect ratio based on width/height
      width={1000}  // Set the width
      height={400}  // Set the height to maintain a 2:1 aspect ratio (width = 1100px, height = 500px)
    />
  );

  return (
    // <div className="sm:mx-0 md:max-w-full md:mx-[10%]">
    <div className="sm:mx-0">
      {slug ? (
        <Link href={`/blogs/posts/${slug}`} aria-label={title}>
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  );
}
